import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function fadeInTop() {
  const sections = document.querySelectorAll(".js-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const fadeInItems = section.querySelectorAll(".js-fade-in");
    if (!fadeInItems.length) return;

    // 初期状態
    fadeInItems.forEach((item) => {
      gsap.set(item, {
        opacity: 0,
        visibility: "hidden",
        y: 40,
      });

      const checks = item.querySelectorAll(".c-check");
      checks.forEach((check) => {
        check.classList.remove("is-active");
      });
    });

    // Timeline + ScrollTrigger
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 70%",
        once: true,
      },
    });

    fadeInItems.forEach((item, index) => {
      const checks = item.querySelectorAll(".c-check");

      // フェードイン
      tl.to(
        item,
        {
          opacity: 1,
          visibility: "visible",
          y: 0,
          duration: 0.4,
          ease: "sine.inOut",
        },
        index === 0 ? 0 : "-=0.2"
      );

      // c-check 発火
      if (checks.length) {
        tl.add(() => {
          checks.forEach((check) => {
            check.classList.add("is-active");
          });
        }, "+=0.2");
      }
    });
  });
}
